module.exports = __webpack_public_path__ + "static/media/jobs_yellow.5b36586f.svg";